<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <PrintHeaderClientSlim :project="project" />
    </template>

    <PrintProjectHeaderSSP :project="project">
      <template v-slot:header>
        <slot>
          {{ $t('salesReport') }}
        </slot>
      </template>
    </PrintProjectHeaderSSP>

    <div class="content-box">
      <div class="content-box-header">
        <h2>1 {{ $t('roofLayout') }}</h2>
      </div>
      <div class="two-column-grid"></div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.salesRoofSidesAttachments"
      fieldName="roofSidesAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import PrintProjectHeaderSSP from '@/components/Print/PrintProjectHeaderSSP';

export default {
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
    PrintProjectHeaderSSP,
  },
  props: {
    project: { type: Object, required: true },
    pageNumber: { type: Number, default: 1 },
    pageCount: { type: Number, default: 3 },
  },
};
</script>
